import styled from 'styled-components'
import { Formik, Form, Field } from 'formik'
import PropTypes from 'prop-types'

import Button from 'components/Atoms/Button'
import Text from 'components/Atoms/Text'
import { PhoneField } from 'components/Molecules/Form'

import validationSchema from './validationSchema'

const Component = styled(Form)`
  display: none;

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    display: block;
    margin-top: 40px;
  }
`

const Label = styled(Text)`
  margin-bottom: 8px;
`

const PhoneNumberBox = styled.div`
  display: flex;
`

const PhoneNumber = styled(PhoneField)`
  flex: 1;
`

const NextButton = styled(Button)`
  margin-left: 8px;
  margin-top: 4px;
  padding: 0 20px;
  height: 44px;
  color: ${props =>
    props.isLight ? props.theme.palette.grayDark : props.theme.palette.white};
  background-color: ${props =>
    props.isLight ? props.theme.palette.primary : props.theme.palette.grayDark};
  border-color: ${props =>
    props.isLight ? props.theme.palette.primary : props.theme.palette.grayDark};
  opacity: 1;

  &:hover,
  &:focus,
  &:active {
    opacity: 0.9;
  }
`

const PhoneNumberForm = ({
  country,
  error,
  formikRef,
  handleSubmit,
  initialValues,
  isLight,
  onFocusField,
  phoneNumberRef,
  t,
}) => (
  <Formik
    ref={formikRef}
    initialValues={initialValues}
    onSubmit={handleSubmit}
    validationSchema={() => validationSchema(country)}
    render={props => {
      const { isSubmitting, setSubmitting, setStatus } = props

      return (
        <Component>
          <Label className={`${isLight && 'contrastText'} bold uppercase`}>
            {t('howItWorks.hero.phoneNumber.label')}
          </Label>
          <PhoneNumberBox>
            <Field
              inputRef={phoneNumberRef}
              component={PhoneNumber}
              disabled={isSubmitting && !error}
              name="phoneNumber"
              placeholder={t('howItWorks.hero.phoneNumber.placeholder')}
              onFocus={() => onFocusField(setSubmitting, setStatus)}
            />
            <NextButton
              disabled={isSubmitting && !error}
              isLight={isLight}
              type="submit">
              {t('howItWorks.hero.phoneNumber.button').toUpperCase()}
            </NextButton>
          </PhoneNumberBox>
        </Component>
      )
    }}
  />
)

PhoneNumberForm.propTypes = {
  country: PropTypes.string,
  error: PropTypes.string,
  formikRef: PropTypes.object,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  isSubmitting: PropTypes.bool,
  isLight: PropTypes.bool,
  onFocusField: PropTypes.func,
  phoneNumberRef: PropTypes.object,
  setStatus: PropTypes.bool,
  setSubmitting: PropTypes.bool,
  t: PropTypes.func,
}

PhoneNumberForm.defaultProps = {
  isLight: false,
}

export default PhoneNumberForm
